import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CATEGORY, DOC_REQUIRED } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getDocRequiredList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${DOC_REQUIRED.GET_DOC_REQUIRED_LIST}/${data?._Id}`
      : `${DOC_REQUIRED.GET_DOC_REQUIRED_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addDocRequired = async (data = array()) => {
  try {
    const response = await POST(DOC_REQUIRED.GET_DOC_REQUIRED_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateDocRequired = async (id, data = array()) => {
  try {
    const url = `${DOC_REQUIRED.GET_DOC_REQUIRED_LIST}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getDocRequiredDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${DOC_REQUIRED.GET_DOC_REQUIRED_LIST}/${data?.Id}`
      : `${DOC_REQUIRED.GET_DOC_REQUIRED_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchDocRequiredTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${DOC_REQUIRED.GET_DOC_REQUIRED_SCHEMA}/${data?._Id}`
      : `${DOC_REQUIRED.GET_DOC_REQUIRED_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitDocRequiredFilterData = async (data = array()) => {
  try {
    const response = await POST(DOC_REQUIRED.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
